import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Logger } from '@app/core/logger.service';
import { LoginComponent } from '@app/login/login.component';
import { FormTermOfUseComponent } from '@app/shared/forms/account-data-form/form-term-of-use/form-term-of-use.component';
import { EmailNotExistService } from '@app/shared/services/email-not-exist/email-not-exist.service';
import { FilesService } from '@app/shared/services/files/files.service';
import { IonLoaderService } from '@app/shared/services/ion-loader/ion-loader.service';
import { Phone } from '@app/shared/services/lada/lada.service';
import { UtilitiesService } from '@app/shared/services/utilities/utilities.service';
import { EmailNotExist } from '@app/shared/validators/emailNotExist.validator';
import { PhoneValidator } from '@app/shared/validators/phone.validator';
import { Camera, CameraResultType, Photo } from '@capacitor/camera';
import { ActionSheetController, AlertController, LoadingController, ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage-angular';
import { HttpHeaders, HttpService } from '@app/shared/services/http/http.service';
import { environment } from '@env/environment';
import { AuthenticationService } from '@app/core/authentication/authentication.service';
import { FirebaseService } from '@app/shared/services/firebase/firebase.service';
import { Router } from '@angular/router';
import { AnalyticsService } from '@app/shared/services/analytics/analytics.service';
import { AddLocationComponent } from '@app/shared/forms/add-location/add-location.component';
import { PopoverController } from '@ionic/angular';
import { TooltipComponent } from './tooltip/tooltip.component';

const log = new Logger('RegisterComponent');
const folderName = 'register-files';
@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  @ViewChild('file', { read: ElementRef, static: true }) file: ElementRef;
  public dataForm: FormGroup;
  public dataFormEsp: FormGroup;
  public step: number = 1;
  public isLoading: boolean = false;
  public phone: Phone = {
    number: '',
    lada: '52',
    color: 'light',
    country: 'MEXICO',
    error: false
  };
  public isTransitioning: boolean = false;
  showPassword: boolean = false;
  public metaType: any[] = [
    {
      value: 'medico',
      label: 'Médico'
    },
    {
      value: 'medico-en-formacion',
      label: 'Médico en formación'
    },
    {
      value: 'profesional-de-la-salud',
      label: 'Otros profesionales de la salud'
    }
  ];
  public educationalLevelOptions: any[] = [
    {
      value: 'estudiante',
      label: 'Estudiante'
    },
    {
      value: 'tecnico',
      label: 'Técnico'
    },
    {
      value: 'universitario',
      label: 'Universitario'
    }
  ];
  estimatedGraduationTimeOptions = environment.ESTIMATED_GRADUATION_TIME_OPTIONS;
  personalInterests: any[] = [];
  selectLabel: string = 'Tiempo para finalizar';

  constructor(
    private analyticsFB: AnalyticsService,
    private router: Router,
    private loader: IonLoaderService,
    public formBuilder: FormBuilder,
    private emailNotExistService: EmailNotExistService,
    private utilities: UtilitiesService,
    private storage: Storage,
    private modalCtrl: ModalController,
    private alertCtrl: AlertController,
    private filesService: FilesService,
    private http: HttpService,
    private authServe: AuthenticationService,
    private fireService: FirebaseService,
    private actionSheetCtrl: ActionSheetController,
    private popoverCtrl: PopoverController,
    private loadingCtrl: LoadingController
  ) {
    this.initForm();
    this.initFormEsp();
    try {
      if (!this.storage.driver || !this.storage['_db']) {
        this.storage.create();
      }
    } catch {
      this.storage.create();
    }
  }

  private initForm() {
    this.dataForm = this.formBuilder.group({
      name: ['', [Validators.required]],
      lastName1: ['', [Validators.required]],
      lastName2: ['', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          )
        ],
        [EmailNotExist.createValidator(this.emailNotExistService)]
      ],
      password: ['', [Validators.required, Validators.minLength(6)]],
      mobile: ['', [Validators.required, PhoneValidator.isValid]],
      mobileLada: [this.phone.lada, [Validators.required]],
      phoneCountry: [this.phone.country, [Validators.required]],
      termsAndConditions: [false, Validators.required],
      postal_code: ['', [Validators.required, Validators.pattern(/^[0-9]{5}$/)]],
      state: ['', [Validators.required]],
      delegation: ['', [Validators.required]],
      colony: ['', [Validators.required]],
      city: ['', [Validators.required]]
    });
  }

  private initFormEsp() {
    this.dataFormEsp = this.formBuilder.group({
      metaType: ['medico', [Validators.required]],
      cedula: ['', [Validators.required, Validators.pattern(/^[0-9]{7,8}$/)]],
      personalInterests: ['', [Validators.required]],
      verificationFile: [''],
      estimatedGraduationTime: [''],
      educationalLevel: ['']
    });
  }

  async inializeApp() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      this.refillForm2();
      await this.initPersonalInterests();
    } catch (error) {
      log.error(error);
    }
    await this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  ngOnInit() {
    this.inializeApp();
  }

  private async refillForm2() {
    let data: any = await this.storage.get('conectimed_userDataRegistration');
    if (data) {
      this.dataForm.patchValue({
        name: data && data.data && data.data.name ? data.data.name : '',
        lastName1: data && data.data && data.data.lastName1 ? data.data.lastName1 : '',
        lastName2: data && data.data && data.data.lastName2 ? data.data.lastName2 : '',
        postal_code: data && data.data && data.data.address1 && data.data.address1.postalCode ? data.data.address1.postalCode : '',
        state: data && data.data && data.data.address1 && data.data.address1.state ? data.data.address1.state : '',
        delegation: data && data.data && data.data.address1 && data.data.address1.delegation ? data.data.address1.delegation : '',
        colony: data && data.data && data.data.address1 && data.data.address1.colony ? data.data.address1.colony : '',
        city: data && data.data && data.data.address1 && data.data.address1.city ? data.data.address1.city : '',
        mobile: data && data.data && data.data.mobile ? data.data.mobile : '',
        mobileLada: data && data.data && data.data.mobileLada ? data.data.mobileLada : this.phone.lada,
        phoneCountry: data && data.data && data.data.phoneCountry ? data.data.phoneCountry : this.phone.country,
        email: data && data.email ? data.email : ''
      });
      this._postalCode(data && data.data && data.data.address1 && data.data.address1.postalCode ? data.data.address1.postalCode : '');
    }
  }

  async initPersonalInterests(): Promise<void> {
    try {
      const resp = await this.fireService.afs.collection('doctor-preferences').ref.where('status', '==', 'active').orderBy('nameStr').get();
      this.personalInterests = resp.docs.map(e => {
        const DATA: any = e.data();
        const ID: string = e.id;
        return { ...DATA, id: ID }
      });
    } catch (error) {
      log.error(error);
    }
  }

  async transitionToStep(newStep: number) {
    this.isTransitioning = true;
    // Pequeña pausa para permitir que la animación de salida se complete
    await new Promise(resolve => setTimeout(resolve, 300));
    this.step = newStep;
    // Pequeña pausa para permitir que la animación de entrada se complete
    await new Promise(resolve => setTimeout(resolve, 100));
    this.isTransitioning = false;
  }

  emailChange(ev: any) {
    let value: string = ev.detail.value;
    value = value.replace(/\s/g, '');
    this.dataForm.get('email').patchValue(value);
  }

  public async modalLogin() {
    const modal = await this.modalCtrl.create({
      component: LoginComponent
    });
    modal.present();
  }

  async termOfUseComponent(): Promise<void> {
    const modal = await this.modalCtrl.create({
      component: FormTermOfUseComponent
    });
    modal.present();
  }

  async alert() {
    const alert = await this.alertCtrl.create({
      header: 'No se pudo completar el registro',
      message: `Lamentamos el inconveniente. Ocurrió un problema al procesar su registro.
      Por favor, inténtelo nuevamente en unos minutos. Si el error persiste,
      comuníquese con nuestro equipo de soporte para que podamos ayudarle.`,
      buttons: ['Aceptar']
    });
    await alert.present();
  }

  analyticsClickEvent(eventName: string, params: {}, cred: any) {
    const route_page_url: any = this.router.routerState.snapshot.url; // Page route
    this.analyticsFB.logEvent(eventName, params, {
      credentials: cred,
      page_data: { route: route_page_url, title: document.title }
    }); // Analytics LOGS
  }

  later(delay: number) {
    return new Promise(resolve => {
      setTimeout(resolve, delay);
    });
  }

  async onMetaTypeChange(event: any) {
    if (event && event.detail && event.detail.value) {
      await this._onMetaTypeChange(event.detail.value);
    }
  }

  async onEducationalLevelChange(event: any) {
    if (event && event.detail && event.detail.value) {
      await this._onEducationalLevelChange(event.detail.value);
    }
  }

  async presentActionSheet() {
    const actionSheet = await this.actionSheetCtrl.create({
      header: 'Seleccione una opción',
      buttons: [
        {
          text: 'Cámara',
          handler: () => {
            this.takePicture();
          }
        },
        {
          text: 'Documento',
          handler: () => {
            this.triggerClick1();
          }
        },
        {
          text: 'Cancelar',
          role: 'cancel',
          data: {
            action: 'cancel',
          },
        },
      ],
    });
    await actionSheet.present();
  }

  triggerClick1() {
    try {
      this.file.nativeElement.click();
    } catch (error) {
      log.error(error);
    }
  }

  async postalCode(event: any) {
    await this._postalCode(event.detail.value);
  }

  async _postalCode(value: string) {
    this.isLoading = true;
    try {
      if (this.dataForm.value.state !== null) {
        this.dataForm.get('state').reset();
      }
      if (this.dataForm.value.delegation !== null) {
        this.dataForm.get('delegation').reset();
      }
      if (this.dataForm.value.colony !== null) {
        this.dataForm.get('colony').reset();
      }
      if (this.dataForm.value.city !== null) {
        this.dataForm.get('city').reset();
      }
      if (value && value.toString().length > 4) {
        const resp = await this.fireService.afs
          .collection('zipcodes')
          .doc(value)
          .ref.get();
        if (resp.exists === true) {
          const response = await this.fireService.afs
            .collection('zipcodes')
            .doc(value)
            .collection('colonies')
            .ref.get();
          const filteredColonies: any[] = Array.from(response.docs.map(e => e.data()));
          if (filteredColonies.length == 0) {
            this.addLocation();
          }
          if (filteredColonies.length > 0) {
            this.dataForm.get('state').setValue(filteredColonies[0].state);
            this.dataForm.get('delegation').setValue(filteredColonies[0].city);
            this.dataForm.get('colony').setValue(filteredColonies[0].colony);
            if (filteredColonies[0].state === 'Ciudad de México') {
              this.dataForm.get('city').setValue('Ciudad de México');
            } else {
              this.dataForm.get('city').setValue(filteredColonies[0].city);
            }
          }
          if (filteredColonies.length > 1) {
            const inputs: any[] = [];
            this.dataForm.get('state').setValue(filteredColonies[0].state);
            this.dataForm.get('delegation').setValue(filteredColonies[0].city);

            filteredColonies.forEach((colony, index) => {
              inputs.push({
                value: index,
                label: colony.colony,
                type: 'radio'
              });
            });

            const alert = await this.alertCtrl.create({
              backdropDismiss: false,
              header: 'Seleccione una colonia',
              subHeader: `Hay ${filteredColonies.length} colonias que comparten el mismo código postal. Seleccione una, por favor.`,
              inputs,
              buttons: [
                {
                  text: 'Cancelar',
                  cssClass: 'ion-text-danger',
                  handler: () => {
                    this.dataForm.get('postal_code').setValue(null);
                    this.dataForm.get('state').reset();
                    this.dataForm.get('delegation').reset();
                    this.dataForm.get('colony').reset();
                    this.dataForm.get('city').reset();
                  }
                },
                {
                  text: 'Aceptar',
                  handler: (data: any) => {
                    if (data !== undefined) {
                      const selectedColony = filteredColonies[data];
                      this.dataForm.get('colony').setValue(selectedColony.colony);
                      if (selectedColony.state === 'Ciudad de México') {
                        this.dataForm.get('city').setValue('Ciudad de México');
                      } else {
                        this.dataForm.get('city').setValue(selectedColony.city);
                      }
                      return true;
                    } else {
                      this.utilities.presentAlert("", "Seleccione una opción por favor")
                      return false;
                    }
                  }
                }
              ]
            });
            alert.present();
          }
        } else {
          this.addLocation();
        }
      }
    } catch (error) {
      log.error(error);
    }
    this.isLoading = false;

  }

  async addLocation(): Promise<any> {
    const alert = await this.alertCtrl.create({
      backdropDismiss: false,
      header: 'No se encontró código postal',
      message: '¿Desea agregar la locación manualmente?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel',
          cssClass: 'secondary',
          handler: async () => {
            this.dataForm.get('postal_code').setValue(null);
            this.dataForm.get('state').reset();
            this.dataForm.get('delegation').reset();
            this.dataForm.get('colony').reset();
            this.dataForm.get('city').reset();
          }
        },
        {
          text: 'Agregar',
          handler: async () => {
            const modal = await this.modalCtrl.create({
              component: AddLocationComponent,
              componentProps: {
                zipcode: String(this.dataForm.get('postal_code').value),
                uid: '' //this.user.uid
              }
            });
            modal.onDidDismiss().then(resp => {
              if (resp && resp.data && resp.data.location) {
                this.dataForm.get('state').setValue(resp.data.location.state);
                this.dataForm.get('delegation').setValue(resp.data.location.delegation);
                this.dataForm.get('colony').setValue(resp.data.location.colony);
                this.dataForm.get('city').setValue(resp.data.location.city);
              }
            });
            modal.present();
          }
        }
      ]
    });
    alert.present();
  }

  async selectFile(data: any) {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      const file: FileList = data.files as FileList;
      this.dataFormEsp.get('verificationFile').markAsTouched();
      this.dataFormEsp.get('verificationFile').patchValue(file);
      this.dataFormEsp.get('verificationFile').updateValueAndValidity();
    } catch (error) {
      this.utilities.toast('Ha ocurrido un error. Inténtelo más tarde.', '¡Ups!');
      log.error(error);
    }
    await this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  public async takePicture() {
    this.isLoading = true;
    await this.loader.ionLoaderPresent();
    try {
      const image: Photo = await Camera.getPhoto({
        quality: 100,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,

      });
      this.dataFormEsp.get('verificationFile').markAsTouched();
      this.dataFormEsp.get('verificationFile').patchValue(image);
      this.dataFormEsp.get('verificationFile').updateValueAndValidity();
    } catch (error) {
      log.error(error);
    }
    await this.loader.ionLoaderDismiss();
    this.isLoading = false;
  }

  async saveLocal() {
    this.isLoading = true;
    this.disableForm(this.dataForm, 'disable');
    try {
      let name: string = String(this.dataForm.get('name').value).trim().replace(/\s{2,}/g, ' ');
      let lastName1: string = String(this.dataForm.get('lastName1').value).trim().replace(/\s{2,}/g, ' ');
      let lastName2: string = String(this.dataForm.get('lastName2').value).trim().replace(/\s{2,}/g, ' ');
      const email: string = String(this.dataForm.get('email').value).toLocaleLowerCase().trim();
      const password: string = String(this.dataForm.get('password').value);
      const encryptedPassword = this.utilities.encryptFront(password);
      let data = {
        email,
        password: encryptedPassword,
        data: {
          email,
          name: name,
          lastName1: lastName1,
          lastName2: lastName2,
          mobile: String(this.dataForm.get('mobile').value).trim(),
          mobileLada: String(this.dataForm.get('mobileLada').value).trim(),
          phoneCountry: String(this.dataForm.get('phoneCountry').value).trim(),
          address1: {
            postalCode: String(this.dataForm.get('postal_code').value).trim(),
            state: String(this.dataForm.get('state').value).trim(),
            delegation: String(this.dataForm.get('delegation').value).trim(),
            colony: String(this.dataForm.get('colony').value).trim(),
            city: String(this.dataForm.get('city').value).trim()
          }
        }
      };
      await this.storage.set('conectimed_userDataRegistration', data);
      await this.transitionToStep(2);
    } catch (error) {
      log.error(error);
    }
    this.disableForm(this.dataForm, 'enable');
    this.isLoading = false;
  }

  public async beforeRegister() {
    const alert = await this.alertCtrl.create({
      backdropDismiss: false,
      header: 'Registro Conectimed',
      message: `A continuación se le enviará un mensaje de texto al número telefónico que proporcionó con un código para activar su cuenta. Si lo desea puede verificar sus datos antes de continuar.`,
      buttons: [
        {
          text: 'Corregir mis datos',
          role: 'cancel'
        },
        {
          text: 'Continuar',
          handler: () => {
            this.register();
          }
        }
      ]
    });
    alert.present();
  }

  disableForm(form: FormGroup<any>, action: 'disable' | 'enable') {
    if (action === 'disable') {
      form.disable();
    } else {
      form.enable();
    }
  }

  async uploadFile(file: any): Promise<string> {
    try {
      // folderName
      if (file.dataUrl) {
        const response: any = await this.filesService.uploadImageChatFromCamera(file, folderName);
        return response && response.main && response.main.url ? response.main.url : null;
      } else {
        const response: any = await this.filesService.selectAnyFile(file, folderName, ['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'png']);
        return response && response.main && response.main.url ? response.main.url : null;
      }
    } catch (error) {
      log.error(error);
      return null
    }
  }

  async _onMetaTypeChange(value: string) {
    await this.later(200);
    switch (value) {
      case 'medico':
        // Validadores
        this.dataFormEsp.get('cedula').setValidators([Validators.required, Validators.pattern(/^[0-9]{7,8}$/)]);
        this.dataFormEsp.get('verificationFile').clearValidators();
        this.dataFormEsp.get('estimatedGraduationTime').clearValidators();
        this.dataFormEsp.get('educationalLevel').clearValidators();
        // Valores
        this.file.nativeElement.value = "";
        this.dataFormEsp.get('verificationFile').patchValue('');
        this.dataFormEsp.get('estimatedGraduationTime').patchValue('');
        this.dataFormEsp.get('educationalLevel').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        this.dataFormEsp.get('educationalLevel').updateValueAndValidity();
        break;
      case 'medico-en-formacion':
        // Validadores
        this.dataFormEsp.get('verificationFile').setValidators([Validators.required]);
        this.dataFormEsp.get('estimatedGraduationTime').setValidators([Validators.required]);
        this.dataFormEsp.get('cedula').clearValidators();
        this.dataFormEsp.get('educationalLevel').clearValidators();
        // Valores
        this.file.nativeElement.value = "";
        this.dataFormEsp.get('verificationFile').patchValue('');
        this.dataFormEsp.get('cedula').patchValue('');
        this.dataFormEsp.get('educationalLevel').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        this.dataFormEsp.get('educationalLevel').updateValueAndValidity();
        break;
      case 'profesional-de-la-salud':
        // Validadores
        this.dataFormEsp.get('verificationFile').setValidators([Validators.required]);
        this.dataFormEsp.get('estimatedGraduationTime').setValidators([Validators.required]);
        this.dataFormEsp.get('cedula').clearValidators();
        this.dataFormEsp.get('educationalLevel').setValidators([Validators.required]);
        // Valores
        this.file.nativeElement.value = "";
        this.dataFormEsp.get('verificationFile').patchValue('');
        this.dataFormEsp.get('cedula').patchValue('');
        this.dataFormEsp.get('educationalLevel').patchValue('estudiante');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        this.dataFormEsp.get('educationalLevel').updateValueAndValidity();
        break;
    }
  }

  async _onEducationalLevelChange(value: string) {
    await this.later(200);
    switch (value) {
      case 'estudiante':
        // Validadores
        this.dataFormEsp.get('verificationFile').setValidators([Validators.required]);
        this.dataFormEsp.get('cedula').clearValidators();
        this.dataFormEsp.get('estimatedGraduationTime').setValidators([Validators.required]);
        // Valores
        this.dataFormEsp.get('cedula').patchValue('');
        this.dataFormEsp.get('estimatedGraduationTime').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        break;
      case 'tecnico':
        // Validadores
        this.dataFormEsp.get('verificationFile').setValidators([Validators.required]);
        this.dataFormEsp.get('cedula').clearValidators();
        this.dataFormEsp.get('estimatedGraduationTime').clearValidators();
        // Valores
        this.dataFormEsp.get('cedula').patchValue('');
        this.dataFormEsp.get('estimatedGraduationTime').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        break;
      case 'universitario':
        // Validadores
        this.dataFormEsp.get('verificationFile').clearValidators();
        this.dataFormEsp.get('cedula').setValidators([Validators.required, Validators.pattern(/^[0-9]{7,8}$/)]);
        this.dataFormEsp.get('estimatedGraduationTime').clearValidators();
        // Valores
        this.file.nativeElement.value = "";
        this.dataFormEsp.get('verificationFile').patchValue('');
        this.dataFormEsp.get('estimatedGraduationTime').patchValue('');
        // Actualizar validez
        this.dataFormEsp.get('verificationFile').updateValueAndValidity();
        this.dataFormEsp.get('estimatedGraduationTime').updateValueAndValidity();
        this.dataFormEsp.get('cedula').updateValueAndValidity();
        break;
    }
  }

  public async register() {
    // ⬅️ INICIO DEL LOADER
    const loader = await this.loadingCtrl.create({
      message: 'Registrando...',
      spinner: 'crescent'
    });
    await loader.present();
    // ⬅️ FIN: loader inicia antes de todo

    this.isLoading = true;
    this.disableForm(this.dataFormEsp, 'disable');

    try {
      const DATA: any = { ...this.dataForm.value, ...this.dataFormEsp.value };
      const metaType: string = DATA['metaType'] || undefined;
      const encryptedPassword = this.utilities.encryptFront(DATA.password);

      let finaData: any = {
        name: DATA.name,
        lastName1: DATA.lastName1,
        lastName2: DATA.lastName2,
        email: DATA.email,
        password: encryptedPassword,
        mobile: DATA.mobile,
        mobileLada: DATA.mobileLada,
        phoneCountry: DATA.phoneCountry,
        postal_code: DATA.postal_code,
        state: DATA.state,
        delegation: DATA.delegation,
        colony: DATA.colony,
        city: DATA.city,
        personalInterests: DATA.personalInterests,
        type: "medico"
      }

      switch (metaType) {
        case 'medico':
          finaData.metaType = 'medico';
          finaData.cedula = DATA.cedula;
          break;

        case 'medico-en-formacion':
          finaData.metaType = 'medico-en-formacion';
          finaData.verificationFileUrl = await this.uploadFile(DATA.verificationFile);
          finaData.estimatedGraduationTime = DATA.estimatedGraduationTime;
          break;

        case 'profesional-de-la-salud':
          finaData.metaType = 'profesional-de-la-salud';
          finaData.educationalLevel = DATA.educationalLevel;

          if (DATA.educationalLevel === 'estudiante') {
            finaData.verificationFileUrl = await this.uploadFile(DATA.verificationFile);
            finaData.estimatedGraduationTime = DATA.estimatedGraduationTime
          } else if (DATA.educationalLevel === 'tecnico') {
            finaData.verificationFileUrl = await this.uploadFile(DATA.verificationFile);
          } else if (DATA.educationalLevel === 'universitario') {
            finaData.cedula = DATA.cedula;
          }
          break;
      }

      try {
        const headers: HttpHeaders = {
          'Content-Type': 'application/json'
        };

        const response = await this.http
          .post(
            `${environment.FIREBASE_API}userAppRegister`,
            finaData,
            { headers: headers }
          );

        try {
          await this.authServe.fireAuth.signInWithCustomToken(response.token);
          await this.fireService.sendMobileVerification({
            number: this.utilities.normalizeMxNumber(finaData.mobileLada + finaData.mobile),
            uid: response.user.uid
          });
          this.storage.remove('conectimed_userDataRegistration');
        } catch (e) {
          this.alert();
          log.error(e);
        }

        this.analyticsClickEvent(
          'click',
          {
            content_type: 'Información personal',
            section_name: 'Registro de usuario',
            click_text: 'Siguiente',
            user_type: 'medico'
          },
          { uid: response.user.uid, email: finaData.email, type: finaData.type }
        );

        this.dataForm.reset();
        this.dataFormEsp.reset();
        this.dataForm.updateValueAndValidity();
        this.dataFormEsp.updateValueAndValidity();
        this.dataForm.disable();
        this.dataFormEsp.disable();

      } catch (error) {
        log.error(error);
      }

    } catch (error) {
      this.alert();
      log.error(error);
    }

    this.disableForm(this.dataFormEsp, 'enable');
    this.isLoading = false;

    // ⬅️ FINAL: cerrar loader pase lo que pase
    await loader.dismiss();
  }

  async showTooltip(ev: any, text: string) {
    const popover = await this.popoverCtrl.create({
      component: TooltipComponent,
      componentProps: {
        text: text
      },
      event: ev,
      showBackdrop: false,
      cssClass: 'tooltip-popover'
    });

    await popover.present();
  }

  onSelectOpen() {
    this.selectLabel = 'Tiempo para finalizar estudios';
  }

  onSelectClose() {
    this.selectLabel = 'Tiempo para finalizar';
  }
}
